import { __assign, __rest } from "tslib";
import { FilterBy, HarmonyEntity, } from '@office-start/command-types';
import { FileType } from '@office-start/document-types';
import create from 'zustand';
export var useHarmonyCommandStore = create(function (set, get) { return ({
    App: {
        entity: HarmonyEntity.App,
    },
    Content: {
        entity: HarmonyEntity.Content,
    },
    People: {
        entity: HarmonyEntity.People,
    },
    Template: {
        entity: HarmonyEntity.Template,
    },
    Draft: {
        entity: HarmonyEntity.Draft,
    },
    getEntity: function (entity) {
        return get()[entity];
    },
    clear: function (entity, fileType) {
        var _a;
        // $TODO: Should this live here?
        // $TODO: If the navigation was initiated by a command, or a link click, we'll need to take that into account and probably not clear the filters inside useCommanding
        var entityState = { entity: entity };
        if (fileType !== undefined && fileType !== FileType.Unknown) {
            entityState.filter = [
                { by: FilterBy.FileType, fileType: fileType, source: 'user' },
            ];
        }
        set(__assign(__assign({}, get()), (_a = {}, _a[entity] = entityState, _a)));
    },
    updateEntity: function (entityState) {
        var _a;
        set(__assign(__assign({}, get()), (_a = {}, _a[entityState.entity] = entityState, _a)));
    },
}); });
export var UnreactiveHarmonyCommandStore = {
    getEntity: function (entity) {
        return useHarmonyCommandStore.getState()[entity];
    },
    getState: function () {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        var _a = useHarmonyCommandStore.getState(), clear = _a.clear, updateEntity = _a.updateEntity, harmonyEntityState = __rest(_a, ["clear", "updateEntity"]);
        return harmonyEntityState;
    },
    clear: function (entity, appName) {
        useHarmonyCommandStore.getState().clear(entity, appName);
    },
    updateEntity: function (state) {
        useHarmonyCommandStore.getState().updateEntity(state);
    },
};
//# sourceMappingURL=store.js.map